export enum LayoutType {
  TwoColumn = '2 column',
  ThreeColumn = '3 column',
}
